import { render } from "./CustomerRatings.vue?vue&type=template&id=1833ad50&scoped=true&ts=true"
import script from "./CustomerRatings.vue?vue&type=script&lang=ts"
export * from "./CustomerRatings.vue?vue&type=script&lang=ts"

import "./CustomerRatings.vue?vue&type=style&index=0&id=1833ad50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1833ad50"]])

export default __exports__